export default __webpack_public_path__ + "static/media/V490_CoC.f18eca11.pdf";